// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".AuthorHeader-cls1___fc219a81de2d804cc39{/*!*/}.AuthorHeader-cls2__c6fbe675ab33beb8436c{border-radius:50%;display:block}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "AuthorHeader-cls1___fc219a81de2d804cc39",
	"cls2": "AuthorHeader-cls2__c6fbe675ab33beb8436c AuthorHeader-cls1___fc219a81de2d804cc39"
};
export default ___CSS_LOADER_EXPORT___;
